import React from 'react';
import { NavLink } from 'react-router-dom';

/**
 * Same tab strip on agreement flow + post-sale pages so labels and columns align.
 */
export default function InfrastructureLeasingBuyerPostSaleTabs({ basePath }) {
  const tabLink = ({ isActive }) =>
    `nav-link ile-buyer-post-sale__tab-link ${isActive ? 'active' : ''}`;

  return (
    <ul className="nav nav-tabs ile-buyer-post-sale__tabs mb-4" role="tablist">
      <li className="nav-item ile-buyer-post-sale__tab-item text-center">
        <NavLink to={`${basePath}/agreement`} className={tabLink} end>
          Agreement
        </NavLink>
      </li>
      <li className="nav-item ile-buyer-post-sale__tab-item text-center">
        <NavLink to={`${basePath}/payment`} className={tabLink} end>
          Payment
        </NavLink>
      </li>
      <li className="nav-item ile-buyer-post-sale__tab-item text-center">
        <NavLink to={`${basePath}/invoice`} className={tabLink} end>
          Invoice
        </NavLink>
      </li>
      <li className="nav-item ile-buyer-post-sale__tab-item text-center">
        <NavLink to={`${basePath}/lease-tracking`} className={tabLink} end>
          Lease tracking
        </NavLink>
      </li>
    </ul>
  );
}
